import api from '@/api/fae';
import common from '@/api/common';
import hr from '@/api/hr';

import Loading from '@/components/Loading';
import multiple from "@/view/fae/components/multiple";
import vradio from "@/view/fae/components/vradio";
import intelligent from "@/view/fae/components/intelligent";

export default {
    components: {multiple, vradio, intelligent, Loading},
    data() {
        return {
            isSchedule: 0,  // 日程
            type: 'add',       // 默认是新增，edit
            dateFormat: 0, // 数据格式
            editData: {},      // 编辑数据
            remark: '',       // 预约事项说明
            start_date: "",   // 表单显示 开始时间
            end_date: "",     // 表单显示 结束时间

            start_currentDate: new Date(),  // 弹框显示 开始时间
            end_currentDate: new Date(),    // 弹框显示 结束时间

            minDate: new Date(2020, 0, 1),    // 弹框选择日期 最小
            maxDate: new Date(2026, 12, 1),   // 弹框选择日期 最大
            is_start_date_show: false, // 弹框显示开始日期
            is_end_date_show: false,   // 弹框显示结束日期
            create_datatime: this.Common.formatDate(new Date()), // 创建日期 提交表单使用
            updata_datatime: this.Common.formatDate(new Date()),
            faeid: '',        // FAE ID
            faedept: '',        // FAE 部门
            faename: '',
            applyid: '',     // 申请人id
            applyname: '',     // 用户中文名
            applyEname: '',    // 用户英文名
            applyTime: '',    // 申请时间
            addressInfo: null,
            isEdit: false,    // 新增还是修改  默认是新增false
            entityId: '',   // FAE记录ID

            segment: [], // 数据
            segmentVal: '', // 用于搜索 value的值
            segmentValLabel: '',


            appointmentTypeVal: '', // 预约类型
            appointmentTypeLabel: '',

            emergencyLevel: [],
            emergencyLevelVal: '',
            emergencyLevelLabel: '',


            productlineVal: '', // 产品线显示
            productlineLabel: '',

            projectVal: '',   // 项目
            projectLabel: '',

            customerVal: 0,  // 客户
            customerLabel: '',
            customerProject: '', // 项目关联客户

            isSubmit: false,  // 是否提交中  避免多次提交
            islock: false,    // 同步外出单
            peerPerson: '',    // 外出单 同行人员
            loading: false, // 加载中
            source: ''
        };
    },
    watch: {},
    computed: {
        wheight() {
            let h = document.body.clientHeight || document.body.clientHeight || document.documentElement.clientHeight;
            if (h) {
                return h
            } else {
                return 400
            }

        }
    },
    mounted() {
        this.initData();
        this.dateFormat = this.$route.query.dateFormat;

        if (this.CoreNew.WEB_URL_SOURCE) {
            this.source = this.CoreNew.WEB_URL_SOURCE
        }
    },

    methods: {
        initData() {
            let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'));
            if (this.$route.query.type == 'edit') {
                this.type = 'edit';
                this.findDicInfoDictionary();
            }
            if (this.$route.query.type == 'see') {
                this.type = 'see';
            } else {
                this.type = 'add';
                this.applyname = ADMIN.USER_NAME;
                this.applyEname = ADMIN.USER_ACCOUNT;
                this.applyid = ADMIN.USER_ID;
                this.applyTime = this.Common.timestampToTime(new Date());
                this.findDicInfoDictionary();
            }

            if (this.$route.query.entityId) {
                this.entityId = this.$route.query.entityId;
                this.getComData()
            }
            if (this.$route.query.isSchedule) {
                this.isSchedule = Number(this.$route.query.isSchedule);
            }

            if (this.$route.query.id) {
                this.faeid = parseInt(this.$route.query.id)
            }
            if (this.$route.query.faedept) {
                this.faedept = this.$route.query.faedept
            }
            if (this.$route.query.name) {
                this.faename = this.$route.query.name
            }
            if (this.$route.query.date) {
                let currentHours = new Date().getHours();
                let st = new Date(this.$route.query.date);
                let et = new Date(this.$route.query.date);

                if (this.$route.query.sdate) {
                    st.setHours(parseInt(this.$route.query.sdate));
                    st.setMinutes(0);
                    st.setSeconds(0);
                    et.setHours(parseInt(this.$route.query.sdate) + 1);
                    et.setMinutes(0);
                    et.setSeconds(0);
                } else {
                    if (currentHours > 12) {
                        st.setHours(13);
                        st.setMinutes(0);
                        st.setSeconds(0);
                        et.setHours(17);
                        et.setMinutes(0);
                        et.setSeconds(0);
                    } else {
                        st.setHours(9);
                        st.setMinutes(0);
                        st.setSeconds(0);
                        et.setHours(12);
                        et.setMinutes(0);
                        et.setSeconds(0);
                    }
                }

                this.start_currentDate = st;
                this.end_currentDate = et;
                this.start_date = this.Common.timestampToTime(this.start_currentDate);
            }

        },

        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            } else if (type === 'hour') {
                return `${val}时`;
            } else if (type === 'minute') {
                return `${val}分`;
            }
            return val;
        },
        onSelectDate: function (i) {
            if (this.type == 'see') {
                return
            }
            if (i == 2) {
                this.is_date_type = 2;
                this.is_start_date_show = false;
                this.is_end_date_show = true;
            } else {
                this.is_date_type = 1;
                this.is_end_date_show = false;
                this.is_start_date_show = true;
            }
        },
        OnChangeDate: function () {

        },
        OnConfirmDate: function () {
            if (this.is_date_type == 2) {
                this.end_date = this.Common.timestampToTime(this.end_currentDate);
            } else {
                this.start_date = this.Common.timestampToTime(this.start_currentDate);
            }
            this.is_start_date_show = false;
            this.is_end_date_show = false;
        },
        OnCancelDate: function () {
            this.is_start_date_show = false;
            this.is_end_date_show = false;
        },
        onSubmit() {
            this.isEdit = false;
            this.checkFaeData()
        },
        onSave() {
            this.isEdit = true;
            this.checkFaeData()
        },
        onCancel() {
            // console.log(this.Common.formatDate(this.start_date))
            // console.log(this.isSchedule)

            if (this.type == 'add') {
                this.start_date = this.$route.query.date
            }

            if (this.isSchedule) {
                // this.$router.go(-1)
                this.$router.push({
                    path: '/schedule',
                    query: {
                        date: this.Common.toTimeDate(this.start_date),
                        dateFormat: this.dateFormat,
                        source: this.source,
                    }
                })
            } else {
                this.$router.push({
                    path: '/fae/detail',
                    query: {
                        id: this.faeid,
                        date: this.Common.toTimeDate(this.start_date),
                        dateFormat: this.dateFormat,
                        source: this.source,
                    }
                })
            }
        },
        getComData() {
            if (this.entityId) {
                common.getComData(this.CoreNew.SYSTABLE.FAE, this.entityId).then(res => {
                    if (res && res.flag && res.data) {
                        let data = res.data;
                        // this.editData = data;
                        this.addressInfo = data.ADDRESS;
                        this.applyid = parseInt(data.APPLYER_ID);
                        this.applyTime = data.APPLY_DATE;
                        this.applyname = data.APPLY_ID_NAME;
                        this.create_datatime = data.CREATE_DATETIME;
                        this.end_date = data.END_DATE;
                        this.faeid = data.FAE_EMP;
                        this.faedept = data.FAE_DEPT;
                        this.faename = data.FAE_EMP_NAME;
                        this.remark = data.REMARK;
                        this.start_date = data.START_DATE;
                        this.updata_datatime = data.UPDATE_DATETIME;

                        this.segmentVal = data.SEGMENT; //领域值
                        this.segmentValLabel = data.SEGMENT; //领域值

                        this.productlineVal = data.CRM_SRM_PDT_CATEGORY_ID;//产品线
                        this.productlineLabel = data.CRM_SRM_PDT_CATEGORY_ID_NAME;//产品线

                        this.projectVal = data.CRM_PJ_PROJECT_ID;//项目
                        this.projectLabel = data.CRM_PJ_PROJECT_ID_NAME;//项目

                        this.customerVal = data.CRM_CUSTOMER_MASTER_ID;//客户
                        this.customerLabel = data.CRM_CUSTOMER_MASTER_ID_NAME;//客户

                        this.appointmentTypeVal = data.APPOINTMENT_TYPE;// 预约类型
                        this.appointmentTypeLabel = data.APPOINTMENT_TYPE_NAME;// 预约类型

                        this.emergencyLevelVal = data.EMERGENCY_LEVEL;// 紧急等级
                        this.emergencyLevelLabel = data.EMERGENCY_LEVEL_NAME;// 紧急等级
                    } else {
                        this.$toast("网络异常，请稍后再试！");
                    }
                })
            }
        },

        checkFaeData() {
            let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'));
            let userId = ADMIN.USER_ID;
            let sDateTime = this.start_date.replace(/\-/g, '/');
            let eDateTime = this.end_date.replace(/\-/g, '/');

            let entityId = this.entityId; // FAE记录ID  跟新需要传入记录id

            let startTimeY = new Date(sDateTime).getFullYear();
            let startTimeM = new Date(sDateTime).getMonth();
            let startTimeD = new Date(sDateTime).getDate();

            let endTimeY = new Date(eDateTime).getFullYear();
            let endTimeM = new Date(eDateTime).getMonth();
            let endTimeD = new Date(eDateTime).getDate();

            if (startTimeY != endTimeY || startTimeM != endTimeM || startTimeD != endTimeD) {
                this.$toast("目前不能跨天预约");
                return
            }

            if (!this.remark) {
                this.$toast("预约事项不能为空");
                return
            }

            if (new Date(sDateTime).getTime() >= new Date(eDateTime).getTime()) {
                this.$toast("结束时间不能早于或等于开始时间！");
                return
            }

            if (new Date(eDateTime).getTime() < (new Date(sDateTime).getTime() + 1000 * 60 * 30)) {
                this.$toast("预约时间不能小于30分钟！");
                return
            }


            if (!this.appointmentTypeVal) {
                this.$toast("预约类型不能为空");
                return
            }

            if (!this.emergencyLevelVal) {
                this.$toast("紧急等级不能为空");
                return
            }


            if (this.start_date && this.end_date && this.faeid) {
                api.faeSubscribeVerify(this.faeid, this.start_date, this.end_date, '').then(res => {

                    if (res && res.flag && res.data) {
                        if (res.data.verifyFlag == 'Y') {

                            if (this.isEdit) {
                                this.upComData(); // 编辑
                            } else {
                                this.addData();   // 新增
                            }
                        } else {
                            this.$toast(res.data.verifyMsg);
                        }
                    } else {
                        this.$toast("网络异常，请稍后再试！");
                        // this.$toast(this.start_date);
                    }
                })
            }


        },

        // 流程发起加入
        addData() {
            if (this.isSubmit) {
                return
            }
            this.isSubmit = true;
            this.loading = true;
            let startTime = this.Common.timestampToTimeT(this.start_date);

            // this.$toast(startTime);
            let params = {
                "HEADER": {
                    "ENTITY_ID": 898,
                    "INFO": {
                        ADDRESS: this.addressInfo,
                        APPLY_ID: this.applyid.toString(),
                        APPLY_DATE: this.applyTime,
                        END_DATE: this.end_date,
                        FAE_EMP: this.faeid,
                        FAE_DEPT:this.faedept,
                        NOTE: null,
                        REMARK: this.remark,
                        START_DATE: this.start_date,
                        SEGMENT: this.segmentVal,   //领域
                        TEMP_CUSTOMER: null,
                        CRM_SRM_PDT_CATEGORY_ID: this.productlineVal.toString(), //产品线
                        CRM_SRM_PDT_CATEGORY_LABEL: null,  // 必传
                        CRM_PJ_PROJECT_ID: this.projectVal,//项目
                        CRM_CUSTOMER_MASTER_ID: this.customerVal, // 客户 数字
                        CRM_CUSTOMER_MASTER_ID_NAME: this.customerLabel,
                        APPOINTMENT_TYPE: this.appointmentTypeVal, // 预约类型
                        EMERGENCY_LEVEL: this.emergencyLevelVal,   // 紧急等级
                        DATA_SOURCES: 'ADD_Mobile',
                        STARTTIME: startTime, // 定时发起流程时间
                    }
                },
                "DETAIL": {}
            };
            common.initProcess(this.applyEname, params).then(res => {
                this.isSubmit = false;
                this.loading = false;
                if (res && res.flag) {
                    this.$toast("添加成功！");

                    if (this.islock) {
                        this.tripBillApply(); // 外出
                    } else {
                        this.$router.push({
                            path: '/fae/detail',
                            query: {
                                id: this.faeid,
                                date: this.Common.formatDate(this.start_currentDate),
                                dateFormat: this.dateFormat,
                                source: this.source,
                            }
                        })
                    }

                } else {
                    this.$toast("网络异常，请稍后再试！");
                }
            })
        },

        // 更新
        upComData() {
            if (this.isSubmit) {
                return
            }
            this.isSubmit = true;
            this.loading = true;
            let params = {
                ADDRESS: this.addressInfo,
                APPLY_ID: this.applyid.toString(),
                APPLY_DATE: this.applyTime,
                END_DATE: this.end_date,
                FAE_EMP: this.faeid,
                FAE_DEPT:this.faedept,
                NOTE: null,
                REMARK: this.remark,
                START_DATE: this.start_date,
                SEGMENT: this.segmentVal,   //领域
                TEMP_CUSTOMER: null,
                CRM_SRM_PDT_CATEGORY_ID: this.productlineVal.toString(), //产品线
                CRM_SRM_PDT_CATEGORY_LABEL: null,  // 必传
                CRM_CUSTOMER_MASTER_ID: this.customerVal, // 客户 数字
                CRM_PJ_PROJECT_ID: this.projectVal,//项目
                APPOINTMENT_TYPE: this.appointmentTypeVal, // 预约类型
                EMERGENCY_LEVEL: this.emergencyLevelVal,   // 紧急等级
                DATA_SOURCES: 'UPDATA_Mobile',
            };
            common.upComData(this.CoreNew.SYSTABLE.FAE, this.entityId, params).then(res => {
                this.isSubmit = false;
                this.loading = false;
                if (res && res.flag) {
                    this.$toast("修改成功！");
                    this.$router.push({
                        path: '/fae/detail',
                        query: {
                            id: this.faeid,
                            date: this.Common.formatDate(this.start_currentDate),
                            dateFormat: this.dateFormat,
                            source: this.source,
                        }
                    })
                } else {
                    this.$toast("网络异常，请稍后再试！");
                }
            })
        },

        // 外出
        tripBillApply() {
            let outCategory = "003";  // 003因公外出   004培训外出
            let params = {
                types: outCategory,
                fTripReason: this.remark,        // 外出原因
                fTripStartTime: this.start_date,
                fTripEndTime: this.end_date,
                peerPerson: '',                  // 同行人员
                fTripStartPlace: '出发地点',
                fTripEndPlace: '目的地点',
            };
            hr.tripBillApply(params).then(res => {
                if (res && res.flag) {
                    setTimeout(() => {
                        this.$toast("外出申请提交成功！");
                        this.$router.push({
                            path: '/fae/detail',
                            query: {
                                id: this.faeid,
                                date: this.Common.formatDate(this.start_currentDate),
                                dateFormat: this.dateFormat,
                                source: this.source,
                            }
                        })
                    }, 2000)

                } else {
                    this.$toast("网络异常，请稍后再试！");
                }
            })
        },

        confirmPro(data) {
            this.productlineVal = data;
        },
        confirmCustomer(data) {
            this.customerVal = data;
        },
        confirmProject(data) {
            this.projectVal = data;
            this.getComCustomer(data)
        },
        onchangeProject() {
            console.log("onchangeProject")
            this.projectVal = '';
            this.projectLabel = '';
            this.customerVal = '';
            this.customerLabel = '';
            this.customerProject = '';
        },
        // 根据项目得到客户
        getComCustomer(id) {
            if (id) {
                common.getComData(this.CoreNew.SYSTABLE.PROJECT, id).then(res => {
                    if (res && res.flag && res.data) {
                        let data = res.data;
                        this.customerVal = data.CRM_CUSTOMER_MASTER_ID;//客户
                        this.customerLabel = data.CRM_CUSTOMER_MASTER_ID_NAME;//客户
                        this.customerProject = data.CRM_CUSTOMER_MASTER_ID_NAME;//客户

                    } else {
                        this.$toast("网络异常，请稍后再试！");
                    }
                })
            }
        },

        // 获取 数据字典配置的参数
        findDicInfoDictionary() {
            let fieldName = '';
            let moduleId = this.CoreNew.SYSTABLE.FAE;
            let systemId = '';
            common.findDicInfo(fieldName, moduleId, systemId).then(res => {
                if (res && res.flag && res.data) {
                    let data = res.data;
                    localStorage.setItem('FIND_DIC_INFO_FAE', JSON.stringify(res.data));
                } else {
                    this.$toast("网络异常，请稍后再试！");
                }
            })
        },

        confirmSegment(data) {
            if (this.type == 'see') {
                return
            }
            this.segmentVal = data;
        },
        confirmAppointmentType(data) {
            if (this.type == 'see') {
                return
            }
            this.appointmentTypeVal = data;
        },
        confirmEmergencyLevel(data) {
            if (this.type == 'see') {
                return
            }
            this.emergencyLevelVal = data;
        },
        changeSwitch(value) {
            console.log(value)
            this.islock = value
        }

    }
}
